import { DagStatus } from '@agilelab/plugin-wb-builder-common';
import { WbButton, WbDivider } from '@agilelab/plugin-wb-platform';
import { Box, Button, useTheme } from '@material-ui/core';
import { FC, useState } from 'react';
import { useReleaseDetailPageContext } from '../../context/useReleaseDetailPageContext';
import { Deploy } from '../../types';
import { TerminateDialog } from './TerminateDialog';

interface Props {
  deploy: Deploy;
  canProvision: boolean;
}

export const LatestProvisioningActions: FC<Props> = ({
  deploy,
  canProvision,
}) => {
  const { setIsLogsDrawerOpen, setSelectedDeploy } =
    useReleaseDetailPageContext();
  const theme = useTheme();

  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="end"
        style={{ gap: 16 }}
      >
        {deploy.status === DagStatus.RUNNING && canProvision && (
          <>
            <WbButton
              color="primary"
              variant="contained"
              label="Terminate"
              onClick={() => setOpenDialog(true)}
              style={{
                backgroundColor: theme.palette.error.main,
              }}
            />
            <WbDivider />
          </>
        )}

        <Button
          variant="text"
          color="primary"
          onClick={() => {
            setSelectedDeploy(deploy);
            setIsLogsDrawerOpen(true);
          }}
        >
          Log File
        </Button>
      </Box>
      <TerminateDialog open={openDialog} onClose={() => setOpenDialog(false)} />
    </>
  );
};
